<template>
  <Modal
    class="text-center"
    hide-close-button
    :modal-style="{ width: '375px' }"
    :title="displayTitle"
  >
    <div
      v-if="showTimeLimitMessage"
      class="row q-mb-lg"
    >
      <span>
        This comment has a Time limit applied to it and it expires at
        {{
          formatIntlDate(expiresAt, { dateStyle: "short", timeStyle: "short" })
        }}
      </span>
    </div>
    <QSpinner
      v-if="loading"
      class="full-width q-mt-lg"
      :size="30"
    />
    <div
      v-else
      class="row"
      :style="{ justifyContent: 'center' }"
    >
      <QBtn
        aria-label="Close"
        flat
        label="Close"
        @click="$emit('close')"
      />
      <QBtn
        aria-label="Save comment"
        color="black"
        label="Yes"
        @click.once="saveComment()"
      />
    </div>
  </Modal>
</template>

<script>
import Modal from "shared/components/core/modals/Modal.vue";
import { formatIntlDate } from "shared/helpers/date";

export default {
  name: "ConfirmCommentResolutionModal",
  components: {
    Modal,
  },
  props: {
    closed: {
      type: Boolean,
      required: true,
    },
    expiresAt: {
      type: Date,
      default: () => null,
    },
  },
  emits: ["close", "saveComment"],
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    showTimeLimitMessage() {
      return this.expiresAt && new Date() < this.expiresAt;
    },
    displayTitle() {
      return `Are you sure you would like to ${
        this.closed ? "unresolve" : "resolve"
      } this comment?`;
    },
  },
  methods: {
    formatIntlDate,
    saveComment() {
      this.loading = true;
      this.$emit("saveComment");
    },
  },
};
</script>

<style lang="scss" scoped>
.q-icon {
  font-size: 10em;
}
</style>
